import { ViewMyTickets, EditCustomFields, PurchasedTickets } from 'ui/profile';

export const ProfileRoutes = {
  viewMyTickets: {
    component: ViewMyTickets,
    path: '/profile/view-my-tickets',
  },
  purchasedTickets: {
    component: PurchasedTickets,
    path: '/profile/tickets/purchased',
  },
  editCustomFields: {
    component: EditCustomFields,
    path: '/profile/edit-custom-fields',
  },
  /*ViewMyScheduledOrders: {
    component: ViewMyScheduledOrders,
    path: '/profile/view-my-scheduled-orders',
  },*/
};